export const VerticalDivider: React.FC<{ UNSAFE_className?: string }> = ({
  UNSAFE_className = '',
}) => {
  return (
    <div
      className={`${UNSAFE_className} tw-flex tw-w-px tw-min-w-px tw-max-w-px tw-self-stretch tw-bg-blue-200`}
    ></div>
  );
};
